"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_dates_1 = require("react-dates");

require("react-dates/initialize");

var Wrapper_1 = __importDefault(require("./styles/Wrapper"));
/**
 * DateRange component
 *
 * Extended and customized DateRangePicker from `react-dates`
 * https://github.com/airbnb/react-dates#daterangepicker
 *
 * **NOTE**: _use this webpack plugin if you use this component,
 * or your project will be bloated with useless i18n data
 * https://momentjs.com/docs/#/use-it/webpack/_
 */


var DateRange = function DateRange(_a) {
  var startDate = _a.startDate,
      startDateId = _a.startDateId,
      endDate = _a.endDate,
      endDateId = _a.endDateId,
      focusedInput = _a.focusedInput,
      onDatesChange = _a.onDatesChange,
      onFocusChange = _a.onFocusChange,
      _a$hideKeyboardShortc = _a.hideKeyboardShortcutsPanel,
      hideKeyboardShortcutsPanel = _a$hideKeyboardShortc === void 0 ? true : _a$hideKeyboardShortc,
      _a$showDefaultInputIc = _a.showDefaultInputIcon,
      showDefaultInputIcon = _a$showDefaultInputIc === void 0 ? true : _a$showDefaultInputIc,
      _a$block = _a.block,
      block = _a$block === void 0 ? true : _a$block,
      _a$small = _a.small,
      small = _a$small === void 0 ? false : _a$small,
      _a$inputIconPosition = _a.inputIconPosition,
      inputIconPosition = _a$inputIconPosition === void 0 ? "after" : _a$inputIconPosition,
      rest = __rest(_a, ["startDate", "startDateId", "endDate", "endDateId", "focusedInput", "onDatesChange", "onFocusChange", "hideKeyboardShortcutsPanel", "showDefaultInputIcon", "block", "small", "inputIconPosition"]);

  return react_1["default"].createElement(Wrapper_1["default"], {
    picker: "range",
    small: small
  }, react_1["default"].createElement(react_dates_1.DateRangePicker, Object.assign({
    startDate: startDate,
    startDateId: startDateId,
    endDate: endDate,
    endDateId: endDateId,
    focusedInput: focusedInput,
    onDatesChange: onDatesChange,
    onFocusChange: onFocusChange,
    block: block,
    small: small,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    showDefaultInputIcon: showDefaultInputIcon,
    inputIconPosition: inputIconPosition
  }, rest)));
};

exports["default"] = DateRange;